export function convertToAbsolute(url) {
  if (url.substr(0, 1) !== '/') {
    return url
  }

  return `${url}`
}

export function stripLanguage(relativeUrl) {
  return relativeUrl.replace(/^\/[a-z]{2}\//, '/')
}
export function convertToLanguage(relativeUrl, lang) {
  return `/${lang}${stripLanguage(relativeUrl)}`
}

export function createSlug(input) {
  if (!input.length) {
    return ''
  }

  return input
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
}
